'use client';

import { emailSignup } from 'lib/email/emailSignup';
import { useState } from 'react';
import styles from './styles.module.scss';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import IconButton from 'components/controls/buttons/icon-button';
import Arrow from 'assets/icons/arrow.svg';
import LoadingSpinner from 'assets/icons/loading-spinner.svg';

const NewsLetterSignUpBox = () => {
	const [email, setEmail] = useState('');
	const [showSuccess, setShowSuccess] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [showError, setShowError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [isValid, setIsValid] = useState(true);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isEmailDirty, setIsEmailDirty] = useState(false);
	const emailCode = 'web_footer';

	const submit = async (e) => {
		e.preventDefault();
		const url = window ? window.location.pathname : undefined;
		//Hide Previous Error State
		if (isValid && email != '') {
			setIsSubmitting(true);
			setShowError(false);
			setShowSuccess(false);
			const res = await emailSignup({ email, emailCode, url });
			if (res.success) {
				setShowSuccess(true);
				setSuccessMessage(res.message);
				pushToDataLayer({
					Category: 'Email',
					Action: 'Sign up',
					event: 'FooterNewsletterFormSubmitted',
				});
			} else {
				setIsSubmitting(false);
				setShowError(true);
				setErrorMessage(res.message);
			}
		}
	};

	const checkValidity = (event) => {
		const emailInput = event.target;
		setIsValid(emailInput.validity.valid);
		setIsEmailDirty(true);
	};
	return (
		<section className={styles.newsletter}>
			<form name="footerNewsletter">
				<label className={styles.label} htmlFor="newsletter-email">
					Bring some culture to your inbox.
				</label>
				<div className={styles.helperText}>
					Sign up for our newsletter to receive the latest news on exhibitions,
					collections, programs, and special events.
				</div>
				{!showSuccess ? (
					<div className={styles.inputWrapper}>
						<input
							className={styles.input}
							type="email"
							autoComplete="email"
							id="newsletter-email"
							placeholder="Enter your email address"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							onBlur={checkValidity}
							required={true}
						/>
						<IconButton
							className={`${styles.button} ${styles.redMode}`}
							icon={
								isSubmitting ? (
									<LoadingSpinner className={styles.icon} />
								) : (
									<Arrow className={styles.icon} />
								)
							}
							type="submit"
							onClick={submit}
						/>
					</div>
				) : null}
				{!isValid && isEmailDirty ? (
					<div className={`${styles.formMessage} ${styles.error}`}>
						Please enter a valid email address.
					</div>
				) : null}
				{showError ? (
					<div className={`${styles.formMessage} ${styles.error}`}>
						{errorMessage}
					</div>
				) : null}
				{showSuccess ? (
					<p className={`${styles.formMessage} ${styles.success}`}>
						{successMessage}
					</p>
				) : null}
			</form>
		</section>
	);
};

export default NewsLetterSignUpBox;
